import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-licence-inactive',
  templateUrl: './licence-inactive.component.html',
  styleUrls: ['./licence-inactive.component.css']
})
export class LicenceInactiveComponent {

  constructor(private router: Router) { }

  logout() {
    localStorage.clear();
    this.router.navigate(['/login']);
  }
}
